var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19976 13.0346H13.1998M2.7998 13.0346L5.71046 12.4481C5.86498 12.417 6.00686 12.3409 6.11828 12.2294L12.6341 5.71007C12.9465 5.3975 12.9463 4.89084 12.6336 4.57853L11.2533 3.19981C10.9408 2.88764 10.4344 2.88785 10.1221 3.20029L3.60565 9.72032C3.49444 9.83159 3.4185 9.97318 3.38734 10.1274L2.7998 13.0346Z",
    stroke: "#455468",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit03);
export default __webpack_public_path__ + "static/media/edit-03.ac54d22a2eb4edc35b427b0528496715.svg";
export { ForwardRef as ReactComponent };